import { HttpRequest, IHttpClient } from "@features/shared/request/model";

const SERVER_URL = `${process.env.NEXT_PUBLIC_API_URL}`;

export interface ReEngagementClaimGiftResponse {
    success: boolean;
    expires_at: string;
}

export class TReEngagementApi {
    constructor(private httpClient: IHttpClient) {}

    async claimGift() {
        return await this.httpClient.do<ReEngagementClaimGiftResponse>(`${SERVER_URL}/re-engagement/claim-gift`, "POST");
    }
}

export const ReEngagementApi = new TReEngagementApi(HttpRequest);
